require('latest-createjs');


class Loader {
    constructor(manifest) {
        const loader = new window.createjs.LoadQueue(true);
        this._callbacks = {
            progress: [],
            complete: []
        };
        loader.on('progress', event => {
            this._callbacks.progress.forEach(callback => {
                callback.call(null, event);
            });
        });
        loader.on('complete', event => {
            this._callbacks.complete.forEach(callback => {
                callback.call(null, event);
            });
        });
        loader.loadManifest(manifest, true);
    }
    progress(callback) {
        if (typeof callback === 'function') {
            this._callbacks.progress.push(callback);
        }
    }
    complete(callback) {
        if (typeof callback === 'function') {
            this._callbacks.complete.push(callback);
        }
    }
}

module.exports = Loader;


// WEBPACK FOOTER //
// ./js/loader.js